import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { useEffect } from "react";
import { setLocale, numeral, Grid, Paper, makeStyles, Typography, Button, Divider, LinearProgress, RemoveRedEye, withStyles, lighten, DialogViewInvoice, DataTable } from "../../..";
import moment from "moment";
var useStyles = makeStyles(function (theme) {
  var _leftMain;

  return {
    root: {
      padding: "4px 25px"
    },
    leftMain: (_leftMain = {}, _defineProperty(_leftMain, theme.breakpoints.up("md"), {
      boxShadow: "15px 0 15px -5px #333"
    }), _defineProperty(_leftMain, "padding", "24px"), _defineProperty(_leftMain, "height", "100%"), _defineProperty(_leftMain, "overflowY", "scroll"), _leftMain),
    headerLeftMain: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    dataProject: {
      margin: "10px",
      display: "flex",
      "flex-direction": "column",
      "align-items": "left"
    },
    contact: {
      background: "#ededed45",
      borderRadius: "4px"
    },
    headerProject: {
      display: "flex",
      "align-items": "center",
      justifyContent: "space-between"
    },
    actionsProject: {
      display: "flex",
      justifyContent: "flex-end",
      "max-width": "86%"
    },
    divider: {
      margin: "20px 0",
      height: "4px"
    },
    mr30: {
      margin: "30px"
    },
    icon: {
      width: "80px",
      height: "auto"
    },
    edit: {
      color: theme.palette.pending.main
    },
    header: {
      display: "flex",
      "flex-direction": "row",
      "justify-content": "space-between",
      "align-items": "center"
    },
    text_wrap: {
      "word-wrap": "break-word"
    },
    flex: {
      display: "flex"
    },
    percentagesHeader: {
      display: "flex",
      padding: "0 40px 40px",
      "justify-content": "space-evenly"
    }
  };
});
var BorderLinearSuccessProgress = withStyles({
  root: {
    height: 30,
    backgroundColor: lighten("#77ffb5", 0.5),
    borderRadius: 20
  },
  bar: {
    borderTopLeftRadius: 20,
    borderBottomLeftRadius: 20,
    backgroundColor: "#77ffb5"
  }
})(LinearProgress);
var BorderLinearMediumProgress = withStyles({
  root: {
    height: 30,
    backgroundColor: lighten("#ffe082", 0.5),
    borderRadius: 20
  },
  bar: {
    borderTopLeftRadius: 20,
    borderBottomLeftRadius: 20,
    backgroundColor: "#ffe082"
  }
})(LinearProgress);
var BorderLinearIncompleteProgress = withStyles({
  root: {
    height: 30,
    backgroundColor: lighten("#E95A58", 0.5),
    borderRadius: 20
  },
  bar: {
    borderTopLeftRadius: 20,
    borderBottomLeftRadius: 20,
    backgroundColor: "#E95A58"
  }
})(LinearProgress);

var InfoProject = function InfoProject(props) {
  // console.log("InfoProject props", props);
  var translation = props.translation,
      project = props.project,
      contact = props.contact,
      phases = props.phases,
      locale = props.locale,
      getInvoice = props.getInvoice,
      invoices = props.invoices,
      language = props.language;
  var aPlanTasks = [];
  var aDoCheckTasks = [];
  var aCloseTasks = [];
  var classes = useStyles();
  useEffect(function () {
    setLocale(locale);
  }, [locale]);

  var createPercentage = function createPercentage(stage) {
    switch (stage) {
      case "plan":
        phases.find(function (item) {
          return item.key === "plan";
        }).children.forEach(function (item) {
          createArrayStage("plan", phases.find(function (_item) {
            return _item.key === item;
          }));
        });
        return /*#__PURE__*/React.createElement("div", {
          style: {
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            marginTop: "32px"
          }
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1"
        }, "Plan"), /*#__PURE__*/React.createElement("div", {
          style: {
            minWidth: "250px"
          }
        }, createPercentageBar(aPlanTasks.filter(function (item) {
          return item.status === "done";
        }).length, aPlanTasks.length)));
        break;

      case "docheck":
        phases.find(function (item) {
          return item.key === "docheck";
        }).children.forEach(function (item) {
          createArrayStage("docheck", phases.find(function (_item) {
            return _item.key === item;
          }));
        });
        return /*#__PURE__*/React.createElement("div", {
          style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            marginTop: "32px"
          }
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1"
        }, "Do & Check"), /*#__PURE__*/React.createElement("div", {
          style: {
            minWidth: "250px"
          }
        }, createPercentageBar(aDoCheckTasks.filter(function (item) {
          return item.status === "done";
        }).length, aDoCheckTasks.length)));
        break;

      case "close":
        phases.find(function (item) {
          return item.key === "close";
        }).children.forEach(function (item) {
          createArrayStage("close", phases.find(function (_item) {
            return _item.key === item;
          }));
        });
        return /*#__PURE__*/React.createElement("div", {
          style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            marginTop: "32px"
          }
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1"
        }, "Close"), /*#__PURE__*/React.createElement("div", {
          style: {
            minWidth: "250px"
          }
        }, createPercentageBar(aCloseTasks.filter(function (item) {
          return item.status === "done";
        }).length, aCloseTasks.length)));
        break;

      default:
        break;
    }
  };

  var createPercentageBar = function createPercentageBar(itemsDone, itemsTotal) {
    var valueTotal = itemsDone * 100 / itemsTotal;

    if (valueTotal < 50) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center",
          width: "100%",
          position: "relative"
        }
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          position: "absolute",
          width: "250px",
          textAlign: "center",
          top: "-10px",
          zIndex: "1",
          color: "#000"
        }
      }, Math.round(valueTotal) || 0, " %"), /*#__PURE__*/React.createElement(BorderLinearIncompleteProgress, {
        variant: "determinate",
        value: valueTotal,
        style: {
          width: "100%"
        }
      }));
    } else if (valueTotal <= 99) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center",
          width: "100%",
          position: "relative"
        }
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          position: "absolute",
          width: "250px",
          textAlign: "center",
          top: "-10px",
          zIndex: "1",
          color: "#000"
        }
      }, Math.round(valueTotal) || 0, " %"), /*#__PURE__*/React.createElement(BorderLinearMediumProgress, {
        variant: "determinate",
        value: valueTotal,
        style: {
          width: "100%"
        }
      }));
    } else {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center",
          width: "100%",
          position: "relative"
        }
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          position: "absolute",
          width: "250px",
          textAlign: "center",
          top: "-10px",
          zIndex: "1",
          color: "#000"
        }
      }, Math.round(valueTotal) || 0, " %"), /*#__PURE__*/React.createElement(BorderLinearSuccessProgress, {
        variant: "determinate",
        value: valueTotal,
        style: {
          width: "100%"
        }
      }));
    }
  };

  var createArrayStage = function createArrayStage(stage, item) {
    if (item.children.length === 0 && !item.heading) {
      if (item.repeat) {
        if (checkRecurrencyArray(item.repeats)) {
          switch (stage) {
            case "plan":
              aPlanTasks.push({
                status: "done",
                key: item.key
              });
              break;

            case "docheck":
              aDoCheckTasks.push({
                status: "done",
                key: item.key
              });
              break;

            case "close":
              aCloseTasks.push({
                status: "done",
                key: item.key
              });
              break;

            default:
              break;
          }
        } else {
          switch (stage) {
            case "plan":
              aPlanTasks.push({
                status: "pending",
                key: item.key
              });
              break;

            case "docheck":
              aDoCheckTasks.push({
                status: "pending",
                key: item.key
              });
              break;

            case "close":
              aCloseTasks.push({
                status: "pending",
                key: item.key
              });
              break;

            default:
              break;
          }
        }
      } else {
        switch (stage) {
          case "plan":
            aPlanTasks.push({
              status: item.status,
              key: item.key
            });
            break;

          case "docheck":
            aDoCheckTasks.push({
              status: item.status,
              key: item.key
            });
            break;

          case "close":
            aCloseTasks.push({
              status: item.status,
              key: item.key
            });
            break;

          default:
            break;
        }
      }
    } else {
      item.children.forEach(function (_item) {
        createArrayStage(stage, phases.find(function (__item) {
          return __item.key === _item;
        }));
      });
    }
  };

  var checkRecurrencyArray = function checkRecurrencyArray(tasks) {
    var numTasksCompleted = tasks.filter(function (task) {
      return task.status === "done";
    }).length;

    if (numTasksCompleted === tasks.length) {
      return true;
    } else {
      return false;
    }
  };
  /* Invoices */


  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      openView = _React$useState2[0],
      setOpenView = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      selectedInvoice = _React$useState4[0],
      setSelectedInvoice = _React$useState4[1];

  var handleViewInvoice = function handleViewInvoice(id) {
    if (!openView) {
      // const invoice = invoices.find(invoice => invoice._id === id);
      // console.log("handleItemViewInvoice invoice", invoice);
      getInvoice(id).then(function (response) {
        // console.log("handleViewInvoice", response.data);
        setSelectedInvoice(_objectSpread({}, response.data));
      });
    } else {
      setSelectedInvoice(null);
    }

    setOpenView(!openView);
  }; // eslint-disable-next-line no-unused-expressions


  translation && translation.datatables && translation.datatables.invoices && translation.datatables.invoices.columns.find(function (column) {
    return column.name === "options";
  }) && (translation.datatables.invoices.columns.find(function (column) {
    return column.name === "options";
  }).options = {
    filter: false,
    sort: false,
    viewColumns: false,
    empty: true,
    label: false,
    customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
      return /*#__PURE__*/React.createElement(RemoveRedEye, {
        onClick: function onClick() {
          return handleViewInvoice(tableMeta.rowData[0]);
        }
      });
    }
  });
  return [/*#__PURE__*/React.createElement(DialogViewInvoice, {
    variant: "invoice-view",
    open: openView,
    onClose: function onClose() {
      setOpenView(false);
      setSelectedInvoice(null);
    },
    franchise: true,
    invoice: selectedInvoice,
    translation: translation ? translation.dialogs.view_invoice : null
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.leftMain
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.headerProject
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.headerLeftMain
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, project ? project.name : "Sin nombre", " "))), /*#__PURE__*/React.createElement(Divider, {
    className: classes.divider
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.dataProject
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "primary",
    className: classes.text_wrap
  }, translation ? translation.titles.service_type : "Service type"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.text_wrap
  }, project && translation ? translation.service_type[project.type] : project.type), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "primary",
    className: classes.text_wrap
  }, translation ? translation.titles.project_type : "Project type"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.text_wrap
  }, project ? project.projectType.toUpperCase() : ""), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "primary",
    className: classes.text_wrap
  }, translation ? translation.titles.estimated_value : "Estimated value"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.text_wrap
  }, project ? numeral(project.budget).format("0,0[.]00 $") : ""), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "primary",
    className: classes.text_wrap
  }, translation ? translation.titles.date_start : "Date start"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.text_wrap
  }, project ? moment(project.dateStart).format("DD/MM/YYYY") : ""), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "primary",
    className: classes.text_wrap
  }, translation ? translation.titles.date_end : "End date"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.text_wrap
  }, project ? moment(project.dateEnd).format("DD/MM/YYYY") : ""), /*#__PURE__*/React.createElement("br", null), contact && [/*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "primary",
    className: classes.text_wrap
  }, translation ? translation.titles.contact : "Contact"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.text_wrap
  }, contact ? contact.name : "")]))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 9
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.percentagesHeader
  }, createPercentage("plan"), createPercentage("docheck"), createPercentage("close")), /*#__PURE__*/React.createElement("div", {
    style: {
      "margin-left": "50px"
    }
  }, /*#__PURE__*/React.createElement(DataTable, {
    key: language + "_invoices",
    data: invoices,
    translation: translation ? translation.datatables.invoices : null
  }))))];
};

export { InfoProject };